import {
  Autocomplete,
  Grid,
  InputLabel,
  List,
  ListItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';
import { checklistCompletedOption, machineList, yesNoOption } from '../Data/HFDropDowdData';
import {
  forwardingMaintanceVehicalCheckListoptionList,
  harvestingMaintanceVehicalCheckListoptionList,
} from '../Data/HfInputFieldsData';
import SectionAccordians from 'routes/Pages/components/Accordians/SectionAccordians';
import { EmployeeNameField } from 'routes/Pages/GenTask/components/SharedFormFields';
const dropDownStyles = {
  paddingBottom: '10px',
  fontSize: '0.825rem',
  color: 'black',
};
const autoCompleteSlotProps = {
  paper: {
    sx: {
      '& .MuiAutocomplete-option': {
        fontSize: '0.82rem',
        fontWeight: 500,
      },
    },
  },
};
const HFOtherWorkCloseForm = ({
  otherTaskData,
  setOtherTaskData,
  harvestingMaintenanceCheckListData,
  setHarvestingMaintenanceCheckListData,
  forwadingMaintanceCheckListData,
  setForwadingMaintanceCheckListData,
  machineList,
}) => {
  const combinedMachineOptions = React.useMemo(() => {
    const all = machineList.flatMap(group => group.values);
    return Array.from(new Set(all)); // dedupe
  }, [machineList]);

  const handleOtherTaskDataChange = (name, value) => {
    let updatedData = {
      [name]: value,
    };
    if (name === 'overnightStay') {
      if (value === 'No') {
        updatedData['fullNameAccommodation'] = '';
      }
    }
    setOtherTaskData(prevData => ({
      ...prevData,
      ...updatedData,
    }));
  };
  const handleHarvestingMachineChecklistChange = (name, value) => {
    setHarvestingMaintenanceCheckListData(prevData => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleForwardingMachineChecklistChange = (name, value) => {
    setForwadingMaintanceCheckListData(prevData => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': {
          fontSize: '0.825rem',
        },
        '& .MuiInputBase-root': {
          fontSize: '0.825rem !important',
        },
        paddingBottom: '1rem',
      }}>
      <EmployeeNameField value={otherTaskData['employeeName']} onChange={handleOtherTaskDataChange} isOperator />

      <InputFields
        label="Date & Time"
        helperText={'Enter Clock in Date & Time'}
        name="date_Time"
        required={true}
        value={otherTaskData['date_Time']}
        textFieldType={'datetime-local'}
        width={4}
        handleIpChange={handleOtherTaskDataChange}
      />

      <InputFields
        label="Non Productive Hours"
        name="nonProductiveHours"
        value={otherTaskData['nonProductiveHours']}
        textFieldType={'number'}
        width={4}
        handleIpChange={handleOtherTaskDataChange}
      />

      <InputFields
        label="Reason For Non Productive Hours"
        helperText={'This must be preapproved with your manager'}
        name="reasonForNonProductiveHours"
        value={otherTaskData['reasonForNonProductiveHours']}
        textFieldType={'text'}
        width={4}
        handleIpChange={handleOtherTaskDataChange}
        multiline={true}
      />

      <InputFields
        label="Manager Approved Downtime"
        name="managerApprovedDowntime"
        value={otherTaskData['managerApprovedDowntime']}
        textFieldType={'text'}
        width={4}
        handleIpChange={handleOtherTaskDataChange}
      />

      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles}>
          Site Bonus %
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'siteBonus'}
          value={otherTaskData['siteBonus'] ?? null}
          options={[0, 25, 50, 75, 100]}
          getOptionLabel={option => `${option}`}
          onChange={(event, newValue) => handleOtherTaskDataChange('siteBonus', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>

      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles}>
          Machine Bonus %
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'machineBonus'}
          value={otherTaskData['machineBonus'] ?? null}
          options={[0, 25, 50, 75, 100]}
          getOptionLabel={option => `${option}`}
          onChange={(event, newValue) => handleOtherTaskDataChange('machineBonus', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>

      <InputFields
        label="Manager Feedback"
        name="managerFeedback"
        value={otherTaskData['managerFeedback']}
        textFieldType={'text'}
        width={8}
        handleIpChange={handleOtherTaskDataChange}
        multiline={true}
      />

      <Grid item xs={6} sm={6} md={3}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Machine
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'machine'}
          value={otherTaskData['machine'] || null}
          options={combinedMachineOptions}
          onChange={(event, newValue) => handleOtherTaskDataChange('machine', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <SectionAccordians header={'Daily Maintenance Check List Instructions'}>
          <Typography variant="subtitle1">
            Daily Maintenance Every 10 Hours for Harvester/Forwarder Engine Separate Engine Owners Manual
          </Typography>

          <List>
            <ListItem>1.Check oil and liquid leaks repair if necessary</ListItem>
            <ListItem>2.Check any intake and exhaust air leaks</ListItem>
            <ListItem>3.Check the engine or level</ListItem>
          </List>
          <Typography variant="subtitle1">Bogies</Typography>
          <List>
            <ListItem>1.Check any leaks</ListItem>
          </List>
          <Typography variant="subtitle1">Hydraulic System</Typography>
          <List>
            <ListItem>1.Check any leaks</ListItem>
          </List>
          <Typography variant="subtitle1">Greasing</Typography>
          <List>
            <ListItem>1.Check any faultless operation of the lubrication system</ListItem>
            <ListItem>2.Grease grab/crane and centre section every 10 hours</ListItem>
          </List>
        </SectionAccordians>
      </Grid>
      <Typography variant="subtitle1" sx={{ padding: '0.5rem 1rem' }}>
        Harvesting Maintenance Checklist *{' '}
      </Typography>
      <Grid item xs={6} sm={6} md={12}>
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: '10px', // Rounded corners
            overflow: 'hidden', // Ensures children don’t overflow borderRadius
            boxShadow: 1, // Optional: adds a shadow
          }}>
          <Table border={1} size="small" sx={{ border: '1px solid #ccc', fontSize: '0.825rem' }}>
            <TableHead>
              <TableRow>
                <TableCell width="70%"></TableCell>
                <TableCell>Choose Completed or No Completed</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {harvestingMaintanceVehicalCheckListoptionList.map((item, index) => {
                return (
                  <TableRow key={`${index}_${item.label}`}>
                    <TableCell>{item.label}</TableCell>
                    <TableCell>
                      <Autocomplete
                        size="small"
                        disablePortal
                        name={item.key}
                        value={harvestingMaintenanceCheckListData[item.key] || null}
                        options={checklistCompletedOption}
                        onChange={(event, newValue) => handleHarvestingMachineChecklistChange(item.key, newValue)}
                        sx={{ fontSize: '0.8rem' }}
                        renderInput={params => <TextField {...params} size="small" fullWidth />}
                        fullWidth
                        slotProps={{
                          ...autoCompleteSlotProps,
                        }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Typography variant="subtitle1" sx={{ padding: '0.5rem 1rem' }}>
        Forwarding Maintenance Checklist *
      </Typography>
      <Grid item xs={6} sm={6} md={12}>
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: '10px', // Rounded corners
            overflow: 'hidden', // Ensures children don’t overflow borderRadius
            boxShadow: 1, // Optional: adds a shadow
          }}>
          <Table border={1} size="small" sx={{ border: '1px solid #ccc', fontSize: '0.825rem' }}>
            <TableHead>
              <TableRow>
                <TableCell width="70%"></TableCell>
                <TableCell>Choose Completed or No Completed</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {forwardingMaintanceVehicalCheckListoptionList.map((item, index) => {
                return (
                  <TableRow key={`${index}_${item.label}`}>
                    <TableCell>{item.label}</TableCell>
                    <TableCell>
                      <Autocomplete
                        size="small"
                        disablePortal
                        name={item.key}
                        value={forwadingMaintanceCheckListData[item.key] || null}
                        options={checklistCompletedOption}
                        onChange={(event, newValue) => handleForwardingMachineChecklistChange(item.key, newValue)}
                        sx={{ fontSize: '0.8rem' }}
                        renderInput={params => <TextField {...params} size="small" fullWidth />}
                        fullWidth
                        slotProps={{
                          ...autoCompleteSlotProps,
                        }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Overnight Stay
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'overnightStay'}
          value={otherTaskData['overnightStay'] || null}
          options={yesNoOption}
          onChange={(event, newValue) => handleOtherTaskDataChange('overnightStay', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>
      <InputFields
        label="Full Name (Accommodation)"
        name="fullNameAccommodation"
        required={otherTaskData['overnightStay'] == 'Yes'}
        value={otherTaskData['fullNameAccommodation']}
        textFieldType={'text'}
        multiline={true}
        width={8}
        handleIpChange={handleOtherTaskDataChange}
        disabled={otherTaskData['overnightStay'] != 'Yes'}
      />
      <InputFields
        label="Additional Information"
        name="additionalInformation"
        required={true}
        value={otherTaskData['additionalInformation']}
        textFieldType={'text'}
        multiline={true}
        width={12}
        handleIpChange={handleOtherTaskDataChange}
      />
    </Grid>
  );
};

export default HFOtherWorkCloseForm;
